// How the board shows a price and an edge, wherever it shows them. Pure (no React), so server code — the share card —
// imports it too: `@sharpr/ui/format`.

/** American odds with a + on the plus side: 150 → "+150", -110 → "-110". */
export function formatOdds(odds: number): string {
  return odds > 0 ? `+${odds}` : String(odds);
}

/** EV (a fraction) as a signed percentage to one decimal: 0.052 → "+5.2%". */
export function formatEV(ev: number): string {
  const percentage = ev * 100;
  return `${percentage >= 0 ? '+' : ''}${percentage.toFixed(1)}%`;
}
